import React, { useState, useEffect } from "react";
import myTheme from "../../themes/palette"
import {
  Grid,
  Tooltip,
  Paper,
  Modal,
  Container,
  Typography,
  Button,
  Avatar,
  TextField,
  IconButton,
} from "@material-ui/core";
import { useHistory, useLocation, Link } from "react-router-dom";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Draggable from "react-draggable";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";

//importing icons
import SendIcon from "@material-ui/icons/Send";
import loadingImg from "../../assets/images/loadingImg.gif";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Highlighter from "react-highlight-words";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import SearchIcon from "@material-ui/icons/Search";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import ChatIcon from "@material-ui/icons/Chat";
import useStyles from "./styles";
import { useUserContext } from "../../context/UserContext";
import myImage from "@material-ui/icons/AccountCircle";
import api from "../../Axios/api";

// socket io
import io from "socket.io-client";
const SERVER = "https://digimart-server.onrender.com";

const Chat = () => {
  const classes = useStyles();
  let token = "";
  let userId = "";
  var selectedChatTemp = [];
  var messagesTemp = [];
  const [messageText, setMessageText] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [ChatRecieverUser, setChatRecieverUser] = useState([]);
  const { store } = useUserContext();
  if (store.data !== null) {
    token = store.data.token;
    if (store.data.data) userId = store.data.data._id;
  }

  const messagesPageLink = "/buyer/messages";
  const [openDialogBox, setOpenDialogBox] = React.useState(false);
  const [messages, setMessages] = useState([]);
  var socket = io(SERVER);
  const [selectedChat, setSelectedChat] = useState([]);
  const [textToSearch, setTextToSearch] = useState([""]);
  const search = useLocation().search;
  const urlSellerId = new URLSearchParams(search).get("sellerId");
  const [isLoadingConversation, setIsLoadingConversation] = useState(true);
  const [isLoadingMessages, setIsLoadingMessages] = useState(true);

  // for opening menu of deleting single message
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  // Search User Modal
  const [SearchModal, setSearchModal] = useState(false);
  const [searchedUsers, setSearchedUsers] = useState("");

  //for opening search users model
  const OpenSearchModal = () => {
    setSearchModal(true);
  };

  const handleSearchModal = () => {
    setSearchModal(false);
  };

  //for searching text
  const handlerSearchText = (e) => {
    setTextToSearch([e.target.value]);
  };

  //for confirmation on deletion box
  const handleClickOpenDialogBox = () => {
    setOpenDialogBox(true);
  };

  const handleCloseDialogBox = () => {
    setOpenDialogBox(false);
  };

  function PaperComponent(props) {
    return (
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
  }

  const SendMessage = () => {
    //This is for user u want to chat with, send roomId of chat and userId
    socket.emit("subscribe", {
      room: selectedChat.chatRoomId,
      otherUserId: selectedChat.conversationUser._id,
    });
    //This is to send message to user
    socket.emit("chat", {
      currentLoggedInUserId: userId,
      roomId: messages[0].chatRoomId,
      messageText,
    });
  };

  const updateChatMessageAndConversation = () => {
    socket.on("message", (data) => {
      if (selectedChatTemp.chatRoomId === data.message.chatRoomId) {
        //set messages to new messages
        //console.log("new message", data);
        let temp = messagesTemp;
        temp.push(data.message);
        // console.log("selectd", selectedChat);
        // console.log("tenp messages", temp);
        setMessages([...temp]);
      }
      //In conversation array change last message of conversation
      // and make it bold if conversation is not opened
      const messageRoomId = data.message.chatRoomId;
      //console.log("updated conv", conversations);
      conversations.forEach((conversation) => {
        if (conversation.chatRoomId === messageRoomId) {
          //console.log("conversation matched");
          conversation.message.messageText = data.message.message.messageText;
          if (
            data.message.postedByUser !== userId &&
            selectedChatTemp.chatRoomId !== data.message.chatRoomId &&
            selectedChatTemp.chatRoomId !== undefined
          ) {
            conversation.countOfUnReadMessages =
              conversation.countOfUnReadMessages + 1;
            if (document.getElementById(conversation._id)) {
              document.getElementById(conversation._id).style.fontWeight =
                "bold";
              document.getElementById(conversation._id).style.color = "black";
            }
          }
          if (
            selectedChatTemp.chatRoomId === data.message.chatRoomId &&
            selectedChatTemp.chatRoomId !== undefined
          ) {
            //console.log("active chat matched");
            conversation.countOfUnReadMessages = 0;
            if (document.getElementById(conversation._id)) {
              document.getElementById(conversation._id).style.fontWeight =
                "none";
              document.getElementById(conversation._id).style.color = "none";
            }
          }
        }
      });
      if (conversations.length > 0) setConversations([...conversations]);
      // Scroll to Bottom of Chat
      var myDiv = document.querySelector("#user-messages");
      if (myDiv) myDiv.scrollTop = myDiv.scrollHeight;
    });
  };

  useEffect(() => {
    //scroll to the top of page
    // window.scrollTo(0, 0)
    updateChatMessageAndConversation();
    socket.on("newConversation", (data) => {
      console.log("new conversation data", data, "userid", userId);
      //set conversations to new conversations if new chat
      //if i am recieving a chat or i am an intiating the chat the conversations are reloaded
      if (
        data.chatInitiatorId.toString() == userId.toString() ||
        data.chatRecieverId.toString() === userId.toString()
      ) {
        api
          .get(`/buyer/chat/conversations/seller-to-buyer`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            setConversations(res.data.recentConversation);
            setIsLoadingConversation(false);
          })
          .catch((error) => console.log(error));
      }
    });
  }, [socket]);

  const changeMessageText = (text) => {
    setMessageText(text);
  };

  const makeConversationOfRoomRead = (conversaton) => {
    //set all messages read of that conversation and get messages that are not read
    api
      .patch(
        `/buyer/chat/${conversaton.chatRoomId}/mark-read`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(async (res) => {})
      .catch((error) => console.log(error));
  };

  //for opening conversation
  const HandleConversationOfUser = async (conversation) => {
    //This is for user u want to chat with, send roomId of chat and userId
    socket.emit("subscribe", {
      room: conversation.chatRoomId,
      otherUserId:
        conversation.conversationUser != null
          ? conversation.conversationUser._id
          : ChatRecieverUser._id,
    });
    makeConversationOfRoomRead(conversation);
    //change bold message and count when read
    //console.log("con", conversation, "selectde chat temp", selectedChat);
    if (conversation !== "") conversation.countOfUnReadMessages = 0;
    if (document.getElementById(conversation._id)) {
      document.getElementById(conversation._id).style.fontWeight = "normal";
      document.getElementById(conversation._id).style.color = "grey";
    }
    //get conversation
    const responseData = await api
      .get(`/buyer/chat/${conversation.chatRoomId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        selectedChatTemp = conversation;
        setSelectedChat(selectedChatTemp);
        //console.log("selected", selectedChatTemp);
        messagesTemp = res.data.conversation;
        setMessages(res.data.conversation);
        setChatRecieverUser(res.data.chatReciever);
        setIsLoadingMessages(false);
      })
      .catch((error) => console.log(error));

    var elem = document.getElementById("user-messages");
    if (elem) {
      elem.scrollTop = elem.scrollHeight;
    }
  };

  //get All Conversations of user
  useEffect(() => {
    //get seller Id from URL if passed in URL and start chat with that seller
    console.log("sellerId", urlSellerId);
    startChatWithUser({ sellerId: urlSellerId });

    //This is to identify current logged in user

    socket.emit("identity", userId);
    //console.log("use effect emitted identity");
    api
      .get(`/buyer/chat/conversations/seller-to-buyer`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        //console.log("recent con", res.data.recentConversation);
        setConversations(res.data.recentConversation);
        if (
          res.data.recentConversation.length > 0 &&
          selectedChatTemp != null
        ) {
          HandleConversationOfUser(res.data.recentConversation[0]);
        }
        setIsLoadingConversation(false);
      })
      .catch((error) => console.log(error));
  }, []);

  const getTimeInCorrectFormat = (timeString) => {
    timeString = new Date(timeString).toISOString();
    const timeString12hr = new Date(timeString).toLocaleTimeString(
      {},
      { timeZone: "UTC", hour12: true, hour: "numeric", minute: "numeric" }
    );
    return timeString12hr;
  };

  //Search Seller
  const searchSeller = async (searchQuery) => {
    await api
      .get(`/buyer/search/store/${searchQuery}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        let data = res.data.data.Stores;
        setSearchedUsers([...data]);
      })
      .catch((error) => console.log(error));
  };

  //start new chat with user
  const startChatWithUser = async (user) => {
    setSearchModal(false);
    let data = "";
    let newConversation = "";
    const initiatedChat = await api
      .post(
        `/buyer/chat/initiate`,
        {
          userIds: [user.sellerId],
          type: "seller-to-buyer",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(async (res) => {
        newConversation = res.data.data.newConversationInitiated;
        //console.log("data", res.data.data);
        HandleConversationOfUser(newConversation);
        if (res.data.data.chatRoom.isNew) {
          window.location.href = messagesPageLink;
          // <Link to={messagesPageLink}></Link>
        }
        // if (res.data.data.chatRoom.isNew && !urlSellerId){
        //   setConversations((prev) => [...prev, newConversation])
        // }
        

      })
      .catch((error) => console.log(error));
  };

  //delete selected chat room
  const deleteSelectedChatRoom = async () => {
    handleCloseDialogBox();
    await api
      .delete(`/buyer/chat/room/${selectedChat.chatRoomId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(async (res) => {
        await api
          .get(`/buyer/chat/conversations/seller-to-buyer`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            setConversations(res.data.recentConversation);
          })
          .catch((error) => console.log(error));
      })
      .catch((error) => console.log(error));
    setSelectedChat([]);
  };

  //delete selected message
  const deleteMessage = async (message) => {
    console.log("del id", message);
    const messageId = message._id;
    const temp = messages.filter((item) => {
      return item._id.toString() !== messageId.toString();
    });
    setMessages(temp);
    await api
      .delete(`/buyer/chat/message/${messageId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log("deleted", res.data);
      })
      .catch((error) => console.log(error));
  };

  return (
    <div>
      <Breadcrumbs
        style={{ paddingTop: 20, paddingBottom: 10 }}
        className={classes.mainAboutusContainer}
        aria-label="breadcrumb"
      >
        <Link
          className={classes.bCrumbLink}
          style={{ textDecoration: "none", color: "#666" }}
          color="inherit"
          to="/"
        >
          Home
        </Link>
        <Typography color="textPrimary">Messages</Typography>
      </Breadcrumbs>

      <Grid container className={classes.root}>
        <Grid
          item
          xs={12}
          sm={12}
          md={3}
          lg={3}
          component={Paper}
          className={classes.leftSideBar}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingBottom: 15,
              borderBottom: "1px solid #e1e1e1",
              padding: 15,
            }}
          >
            <Typography variant="h4" color="primary">
              Messages
            </Typography>
            <Button
              onClick={() => OpenSearchModal()}
              variant="contained"
              color="primary"
            >
              NEW
            </Button>
          </div>

          <Grid
            container
            direction="column"
            style={{
              padding: "10px 0",
              display: "flex",
              justifyContent: "center",
              alignItems: isLoadingConversation ? "center" : "stretch",
            }}
          >
            {!isLoadingConversation ? (
              conversations.map((el, index) =>
                el.conversationUser ? (
                  <Grid
                    item
                    key={index}
                    onClick={() => HandleConversationOfUser(el)}
                    xs={12}
                    style={{
                      cursor: "pointer",
                      padding: "10px 0px",
                      borderBottom: "1px solid #F8F8F8",
                      borderRight: selectedChatTemp.conversationUser
                        ? selectedChatTemp.conversationUser._id === el._id
                          ? `4px solid ${myTheme.palette.primary.main}`
                          : ""
                        : "",
                      background: selectedChatTemp.conversationUser
                        ? selectedChatTemp.conversationUser._id === el._id
                          ? "#F8F8F8"
                          : "none"
                        : "",
                    }}

                    //onClick={() => HandleConversationOfUser(el)}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                        }}
                      >
                        <Avatar
                          src={el.conversationUser.profilePic}
                          alt={myImage}
                          style={{
                            width: 50,
                            height: 50,
                            marginLeft: 15,
                          }}
                        />
                        <div style={{ marginLeft: 12 }}>
                          <Typography
                            variant="subtitle1"
                            style={{
                              fontWeight: "bold",
                              fontSize: 14,
                            }}
                          >
                            {el.conversationUser.name}
                            {el.countOfUnReadMessages > 0 ? (
                              <span
                                style={{ marginLeft: 7 }}
                                className={classes.badge}
                              >
                                {el.countOfUnReadMessages}
                              </span>
                            ) : null}
                          </Typography>

                          <Typography
                            style={{
                              color: "grey",
                              fontSize: 12,
                            }}
                          >
                            <span id={el._id}>{el.message.messageText}</span>
                          </Typography>
                        </div>
                      </div>
                      <div>
                        <Typography
                          style={{
                            color: "grey",
                            paddingRight: 10,
                            fontSize: 12,
                          }}
                        >
                          {el.readByRecipients[0][0].readtAt}
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ) : null
              )
            ) : (
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* <Typography variant="p" style={{ paddingRight: 5 }}>
                  Loading
                </Typography> */}
                <img className={classes.loadingImgDiv} src={loadingImg}></img>
              </div>
            )}
          </Grid>
        </Grid>

        {!isLoadingMessages ? (
          selectedChat.conversationUser != null ? (
            <Grid
              item
              xs={false}
              sm={false}
              md={8}
              lg={5}
              // component={Paper}
              className={classes.MainChatArea}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingBottom: 15,
                  borderBottom: "1px solid #e1e1e1",
                  padding: "15px 0",
                  // position: "fixed",
                }}
              >
                <Typography
                  variant="h3"
                  color="primary"
                  style={{ fontWeight: "bold" }}
                >
                  {selectedChat.conversationUser.name}
                </Typography>
                <TextField
                  variant="standard"
                  placeholder="Search here"
                  onChange={handlerSearchText}
                  InputProps={{
                    endAdornment: (
                      <SearchIcon
                        color="primary"
                        style={{
                          cursor: "pointer",
                        }}
                      />
                    ),
                  }}
                />
              </div>

              <Grid container style={{ padding: "10px 0" }}>
                <div
                  style={{
                    width: "100%",
                    height: "80vh",
                    maxHeight: "410px",
                    display: "flex",
                    flexDirection: "column",
                    overflowY: "scroll",
                    position: "relative",
                  }}
                  id="user-messages"
                >
                  {messages.map((el, index) => (
                    <Grid
                      item
                      key={index}
                      style={{
                        padding: "10px 0px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent:
                            el.postedByUser === userId
                              ? "flex-end"
                              : "flex-start",
                        }}
                      >
                        {el.postedByUser === userId ? (
                          <div
                            style={{
                              display: "flex",
                            }}
                          >
                            <div style={{ marginLeft: 12 }}>
                              <Typography
                                variant="subtitle1"
                                component={Paper}
                                elevation={0}
                                style={{
                                  padding: 10,
                                  fontSize: 15,
                                  color: "#FFF",
                                  boxShadow:
                                    "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                  background: ` ${myTheme.palette.primary.main}`,
                                }}
                              >
                                <Highlighter
                                  highlightClassName="YourHighlightClass"
                                  searchWords={textToSearch}
                                  autoEscape={true}
                                  textToHighlight={el.message.messageText}
                                />
                                <Typography
                                  align="right"
                                  style={{
                                    marginBottom: -5,
                                    fontSize: 9,
                                  }}
                                >
                                  {/* {new Date(el.createdAt).getDate() */}
                                  <span
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <span>{el.createdAt.split("T")[0]}</span>
                                    <span style={{ paddingLeft: 8 }}>
                                      {getTimeInCorrectFormat(el.createdAt)}
                                    </span>
                                  </span>
                                </Typography>
                              </Typography>
                            </div>
                            {/* {console.log("selected", SelectedChat)} */}
                            <Avatar
                              src={store.data.data.profilePic}
                              alt="profile pic"
                              style={{
                                width: 50,
                                height: 50,
                                marginLeft: 15,
                                marginRight: 15,
                                boxShadow:
                                  "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                              }}
                            />
                            <IconButton
                              id={index}
                              key={index}
                              aria-controls="fade-menu"
                              aria-haspopup="true"
                              onClick={() => deleteMessage(el)}
                              style={{
                                padding: 0,
                                backgroundColor: "#FAFAFA",
                                color: "silver",
                              }}
                            >
                              <DeleteOutlinedIcon fontSize="small" />
                            </IconButton>
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                            }}
                          >
                            <Avatar
                              src={ChatRecieverUser.profilePic}
                              alt="profile pic"
                              style={{
                                width: 50,
                                height: 50,
                                marginLeft: 15,
                                boxShadow:
                                  "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                              }}
                            />
                            <div style={{ marginLeft: 12 }}>
                              <Typography
                                variant="subtitle1"
                                component={Paper}
                                elavation={0}
                                style={{
                                  padding: 10,
                                  fontSize: 14,
                                  boxShadow:
                                    "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                }}
                              >
                                <Highlighter
                                  highlightClassName="YourHighlightClass"
                                  searchWords={textToSearch}
                                  autoEscape={true}
                                  textToHighlight={el.message.messageText}
                                />
                                <Typography
                                  align="right"
                                  style={{
                                    marginBottom: -5,
                                    fontSize: 9,
                                  }}
                                >
                                  <span
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      color: "grey",
                                    }}
                                  >
                                    <span>{el.createdAt.split("T")[0]}</span>
                                    <span style={{ paddingLeft: 8 }}>
                                      {getTimeInCorrectFormat(el.createdAt)}
                                    </span>
                                  </span>
                                </Typography>
                              </Typography>
                            </div>
                          </div>
                        )}
                      </div>
                    </Grid>
                  ))}
                </div>
                <Paper
                  style={{
                    position: "absolute",
                    bottom: 0,
                    width: "90%",
                  }}
                >
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Enter message here"
                    onChange={(e) => changeMessageText(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <SendIcon
                          color="primary"
                          fontSize="large"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => SendMessage()}
                        />
                      ),
                    }}
                  />
                </Paper>
              </Grid>
            </Grid>
          ) : (
            <Grid
              item
              xs={false}
              sm={false}
              md={8}
              lg={6}
              // style={{backgroundColor:'#fff', width:'100%'}}
              // component={Paper}
              className={classes.MainChatArea}
            ></Grid>
          )
        ) : (
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* <Typography variant="p" style={{ paddingRight: 5 }}>
              Loading
            </Typography> */}
            <img className={classes.loadingImgDiv} src={loadingImg}></img>
          </div>
        )}

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={3}
          component={Paper}
          style={{ height: "82vh", zIndex: 1 }}
        >
          <div
            className={classes.userDetailsHeaderArea}
          >
            <Typography variant="h4" color="primary" align="center">
              User Details
            </Typography>
          </div>

          {selectedChat.conversationUser != null ? (
            <div align="center">
              <Avatar
                src={selectedChat.conversationUser.profilePic}
                alt={myImage}
                style={{
                  width: 120,
                  height: 120,
                  marginTop: 25,
                  marginBottom: 15,
                  boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                }}
              />
              <div style={{ margin: "20px 0px" }}>
                <Typography style={{ fontWeight: "bold" }}>Name:</Typography>
                <Typography style={{ fontSize: 14 }}>
                  {selectedChat.conversationUser.name}
                </Typography>
              </div>
              <Tooltip
                title={
                  selectedChat.conversationUser.email
                    ? selectedChat.conversationUser.email
                    : "Email"
                }
              >
                <div style={{ margin: "20px 0px" }}>
                  <Typography style={{ fontWeight: "bold" }}>Email</Typography>
                  <Typography style={{ fontSize: 14 }}>
                    {selectedChat.conversationUser.email
                      ? selectedChat.conversationUser.email
                          .toString()
                          .substring(0, 18) + "..."
                      : "Empty"}
                  </Typography>
                </div>
              </Tooltip>
              <div style={{ margin: "20px 0px" }}>
                <Typography style={{ fontWeight: "bold" }}>Phone</Typography>
                <Typography style={{ fontSize: 14 }}>
                  {selectedChat.conversationUser.phoneNumber}
                </Typography>
              </div>
              <Tooltip
                title={
                  selectedChat.conversationUser.address
                    ? selectedChat.conversationUser.address
                    : "Address"
                }
              >
                <div style={{ margin: "20px 0px" }}>
                  <Typography style={{ fontWeight: "bold" }}>
                    Address
                  </Typography>
                  <Typography style={{ fontSize: 14 }}>
                    {selectedChat.conversationUser.address
                      ? selectedChat.conversationUser.address
                          .toString()
                          .substring(0, 18) + "..."
                      : "Empty"}
                  </Typography>
                </div>
              </Tooltip>
              <Button
                variant="contained"
                color="primary"
                onClick={handleClickOpenDialogBox}
              >
                <DeleteOutlineIcon style={{ marginRight: 5 }} />
                Clear Chat
              </Button>
            </div>
          ) : (
            <div></div>
          )}
        </Grid>

        {/* //Deletion dialog box */}
        <div>
          <Dialog
            open={openDialogBox}
            onClose={handleCloseDialogBox}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
          >
            <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
              Delete Chat
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to delete this chat?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={handleCloseDialogBox} color="primary">
                Cancel
              </Button>
              <Button onClick={() => deleteSelectedChatRoom()} color="primary">
                Yes
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        {/* Search User by Name  */}
        <Modal
          open={SearchModal}
          onClose={handleSearchModal}
          onBackdropClick={handleSearchModal}
          className={classes.searchingModal}
        >
          <Container
            component={Paper}
            className={classes.seatchUsersBox}
          >
            <Grid container spacing={4} align="center">
              <Button
                variant="outlined"
                color="primary"
                className={classes.closeBtn}
                onClick={handleSearchModal}
              >
                Close
              </Button>
              <Grid item xs={12} sm={12} md={12}>
                <Typography variant="h4" style={{ fontWeight: "bold" }}>
                  Search Users To Chat
                </Typography>
              </Grid>
              <Grid  xs={12} style={{}}>
                <Grid container style={{ marginBottom: 10 }} justify="center">
                  <Grid item>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      size="small"
                      label=" Search here ..."
                      placeholder="Search ..."
                      onChange={(e) => searchSeller(e.target.value)}
                    />
                  </Grid>
                  <Grid item>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      className={classes.searchBtn}
                      // onClick ={() => searchSeller()}
                    >
                      <SearchIcon />
                      SEARCH
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              {/* Searched users will display here */}

              <TableContainer component={Paper} className={classes.searchedUsersTable} >
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: "bold" }}>Sr#</TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>Logo</TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Store
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Seller
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }}>
                        Category
                      </TableCell>
                      <TableCell style={{ fontWeight: "bold" }} align="right">
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {searchedUsers
                      ? searchedUsers.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell component="th" scope="row">
                              {index + 1}.
                            </TableCell>
                            <TableCell>
                              <Avatar src={row.logo} alt={myImage} />
                            </TableCell>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>{row.sellerName}</TableCell>
                            <TableCell>{row.category}</TableCell>
                            <TableCell align="right">
                              <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => startChatWithUser(row)}
                              >
                                <ChatIcon style={{ marginRight: 5 }} />
                                Chat
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))
                      : null}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Container>
        </Modal>
      </Grid>
    </div>
  );
};

export default Chat;
